import axios from "utils/axios";
import {
  API_BASE_URL,
  API_SCHEDULE_TIME,
  API_SPORTCOURT,
} from "utils/constants";

export const SPORT_COURT_STATUS = {
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
};

export interface SportCourt {
  id: string;
  name: string;
  description: string;
  types: string[];
  status: string;
  photo?: string;
  features: Array<string | { key: string; value: boolean }>;
}

interface Schedule {
  sportCourtTaxId: string;
  rented: boolean;
  value: number;
  rentalTime: number;
}

interface Schedules {
  [key: string]: Schedule;
}

export interface ScheduleFreeTime {
  sportCourtId: string;
  date: string;
  schedules: Schedules;
}

export interface SportCourtScheduleQuery {
  from: string;
  to: string;
  sportCourtId: string;
}

const getById = (id: string) =>
  axios.get<SportCourt>(`${API_BASE_URL}${API_SPORTCOURT.BASE_URL}/${id}`);
const save = (sportCourt: SportCourt) =>
  axios.post<SportCourt>(
    `${API_BASE_URL}${API_SPORTCOURT.BASE_URL}`,
    sportCourt
  );
const update = (id: string, sportCourt: SportCourt) =>
  axios.put<SportCourt>(
    `${API_BASE_URL}${API_SPORTCOURT.BASE_URL}/${id}`,
    sportCourt
  );
const remove = (id: string) =>
  axios.delete(`${API_BASE_URL}${API_SPORTCOURT.BASE_URL}/${id}`);
const listAll = () =>
  axios.get<{ sportCourts: SportCourt[] }>(
    `${API_BASE_URL}${API_SPORTCOURT.BASE_URL}`
  );
const listTime = (query: SportCourtScheduleQuery) =>
  axios.post<ScheduleFreeTime>(
    `${API_BASE_URL}${API_SCHEDULE_TIME.BASE_URL}`,
    query
  );

const sportCourtAPI = {
  getById,
  save,
  update,
  remove,
  listAll,
  listTime,
};

export default sportCourtAPI;
